import { Link } from 'react-router-dom';
import { categoryList, inCategory, genresOf } from '@/lib/catalog';

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 md:gap-4">
      {categoryList.map((category, index) => {
        const list = inCategory(category.key);
        const genres = genresOf(list).slice(0, 4);
        return (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-primary-50/60 md:p-5"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-md ${
                    index === 0
                      ? 'bg-primary-900 text-accent-400'
                      : index === 1
                        ? 'bg-secondary-100 text-secondary-800'
                        : 'bg-accent-100 text-accent-800'
                  }`}
                >
                  <i className={`${category.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {category.label}
                  </h3>
                  <p className="mt-0.5 font-label text-[10px] uppercase tracking-[0.18em] text-foreground-400">
                    {category.enLabel}
                  </p>
                </div>
              </div>
              <span className="font-label text-[11px] text-foreground-400">{list.length} 部</span>
            </div>

            <p className="mt-3 line-clamp-2 text-xs leading-relaxed text-foreground-500">
              {category.intro}
            </p>

            <div className="mt-3 flex items-center justify-between">
              <div className="flex flex-wrap gap-1.5">
                {genres.map((genre) => (
                  <span
                    key={genre}
                    className="rounded-full bg-background-100 px-2 py-0.5 text-[10px] text-foreground-600"
                  >
                    {genre}
                  </span>
                ))}
              </div>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-foreground-400 transition-colors group-hover:bg-primary-900 group-hover:text-background-50">
                <i className="ri-arrow-right-line text-sm" />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}